// src/pages/TermsAndConditions.tsx
const TermsAndConditions = () => {
  return (
    <div className="min-h-screen bg-white text-gray-800">
   

      {/* Main Content */}
      <main className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          {/* Introduction */}
          <section className="mb-12 text-center bg-gray-50 rounded-2xl p-8 shadow-lg border border-gray-200">
            <p className="text-xl text-gray-700 leading-relaxed">
              Welcome to WinBig! Please read these Terms and Conditions carefully before using our services. 
              By accessing or using WinBig, you agree to be bound by these terms.
            </p>
          </section>

          {/* Terms List */}
          <div className="space-y-8">
            {/* Term 1 */}
            <section id="acceptance" className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow border border-gray-200">
              <h2 className="text-2xl font-bold text-primary mb-4 flex items-center gap-3">
                <span className="flex items-center justify-center w-8 h-8 bg-primary rounded-full text-white text-sm">1</span>
                ACCEPTANCE
              </h2>
              <div className="text-gray-700 pl-11">
                <p>
                  By dialing *474# or purchasing tickets on the official WinBig website, you agree to these 
                  Terms & Conditions. If you do not agree, do not use the service.
                </p>
              </div>
            </section>

            {/* Term 2 */}
            <section id="eligibility" className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow border border-gray-200">
              <h2 className="text-2xl font-bold text-primary mb-4 flex items-center gap-3">
                <span className="flex items-center justify-center w-8 h-8 bg-primary rounded-full text-white text-sm">2</span>
                ELIGIBILITY
              </h2>
              <div className="text-gray-700 pl-11">
                <ul className="space-y-2">
                  <li className="flex items-start gap-3">
                    <span className="text-primary mt-1">•</span>
                    <span>Must be 18+ years.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-primary mt-1">•</span>
                    <span>Not restricted by Malawian law.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-primary mt-1">•</span>
                    <span>Employees, directors, and close family of London Winners Ltd are not eligible to win.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-primary mt-1">•</span>
                    <span>Registration and prize collection require accurate details (full name, valid ID, and phone number).</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-primary mt-1">•</span>
                    <span>Identity and age may be verified at any time.</span>
                  </li>
                </ul>
              </div>
            </section>

            {/* Term 3 */}
            <section id="ticket-sales" className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow border border-gray-200">
              <h2 className="text-2xl font-bold text-primary mb-4 flex items-center gap-3">
                <span className="flex items-center justify-center w-8 h-8 bg-primary rounded-full text-white text-sm">3</span>
                TICKET SALES
              </h2>
              <div className="text-gray-700 pl-11">
                <ul className="space-y-2">
                  <li className="flex items-start gap-3">
                    <span className="text-primary mt-1">•</span>
                    <span>Tickets are sold only through shortcode *474# or the official WinBig website.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-primary mt-1">•</span>
                    <span>Valid only within Malawi.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-primary mt-1">•</span>
                    <span>Users must confirm ticket details; errors must be reported immediately.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-primary mt-1">•</span>
                    <span>Tickets cannot be transferred, exchanged, or refunded.</span>
                  </li>
                </ul>
              </div>
            </section>

            {/* Term 4 */}
            <section id="winnings" className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow border border-gray-200">
              <h2 className="text-2xl font-bold text-primary mb-4 flex items-center gap-3">
                <span className="flex items-center justify-center w-8 h-8 bg-primary rounded-full text-white text-sm">4</span>
                WINNINGS & JACKPOTS
              </h2>
              <div className="text-gray-700 pl-11">
                <ul className="space-y-2">
                  <li className="flex items-start gap-3">
                    <span className="text-primary mt-1">•</span>
                    <span>All winnings are subject to Malawian laws and 15% statutory tax.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-primary mt-1">•</span>
                    <span>Jackpots must be claimed within 24 hours and not later than 30 days with proof of accurate registration details.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-primary mt-1">•</span>
                    <span>Smaller prizes follow official payout rules.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-primary mt-1">•</span>
                    <span>If unclaimed within statutory deadlines, winnings are forfeited.</span>
                  </li>
                </ul>
              </div>
            </section>

            {/* Term 5 */}
            <section id="account-rules" className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow border border-gray-200">
              <h2 className="text-2xl font-bold text-primary mb-4 flex items-center gap-3">
                <span className="flex items-center justify-center w-8 h-8 bg-primary rounded-full text-white text-sm">5</span>
                ACCOUNT RULES
              </h2>
              <div className="text-gray-700 pl-11">
                <ul className="space-y-2">
                  <li className="flex items-start gap-3">
                    <span className="text-primary mt-1">•</span>
                    <span>One account per person.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-primary mt-1">•</span>
                    <span>Registration requires accurate details (name, ID, phone, DOB, etc.).</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-primary mt-1">•</span>
                    <span>You are responsible for account security (PIN/password).</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-primary mt-1">•</span>
                    <span>Accounts are non-transferable.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-primary mt-1">•</span>
                    <span>Accounts with false or incomplete details may be suspended, and winnings withheld.</span>
                  </li>
                </ul>
              </div>
            </section>

            {/* Term 6 */}
            <section id="payments" className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow border border-gray-200">
              <h2 className="text-2xl font-bold text-primary mb-4 flex items-center gap-3">
                <span className="flex items-center justify-center w-8 h-8 bg-primary rounded-full text-white text-sm">6</span>
                PAYMENTS
              </h2>
              <div className="text-gray-700 pl-11">
                <ul className="space-y-2">
                  <li className="flex items-start gap-3">
                    <span className="text-primary mt-1">•</span>
                    <span>Play requires pre-funded WinBig wallet.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-primary mt-1">•</span>
                    <span>Deposits are non-refundable.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-primary mt-1">•</span>
                    <span>Daily purchase limits may apply.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-primary mt-1">•</span>
                    <span>No tickets are issued without confirmed payment.</span>
                  </li>
                </ul>
              </div>
            </section>

            {/* Term 7 */}
            <section id="compliance" className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow border border-gray-200">
              <h2 className="text-2xl font-bold text-primary mb-4 flex items-center gap-3">
                <span className="flex items-center justify-center w-8 h-8 bg-primary rounded-full text-white text-sm">7</span>
                COMPLIANCE
              </h2>
              <div className="text-gray-700 pl-11">
                <ul className="space-y-2">
                  <li className="flex items-start gap-3">
                    <span className="text-primary mt-1">•</span>
                    <span>Users must comply with Malawian gaming laws.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-primary mt-1">•</span>
                    <span>Fraud, abuse, or underage play will result in account suspension/termination.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-primary mt-1">•</span>
                    <span>Winnings from non-compliant accounts may be forfeited.</span>
                  </li>
                </ul>
              </div>
            </section>

            {/* Term 8 */}
            <section id="privacy" className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow border border-gray-200">
              <h2 className="text-2xl font-bold text-primary mb-4 flex items-center gap-3">
                <span className="flex items-center justify-center w-8 h-8 bg-primary rounded-full text-white text-sm">8</span>
                PRIVACY & DATA
              </h2>
              <div className="text-gray-700 pl-11">
                <ul className="space-y-2">
                  <li className="flex items-start gap-3">
                    <span className="text-primary mt-1">•</span>
                    <span>User information is collected for account management and compliance.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-primary mt-1">•</span>
                    <span>See Privacy Policy for details on data use.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-primary mt-1">•</span>
                    <span>Users may unsubscribe and close accounts via request.</span>
                  </li>
                </ul>
              </div>
            </section>

            {/* Term 9 */}
            <section id="liability" className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow border border-gray-200">
              <h2 className="text-2xl font-bold text-primary mb-4 flex items-center gap-3">
                <span className="flex items-center justify-center w-8 h-8 bg-primary rounded-full text-white text-sm">9</span>
                LIABILITY DISCLAIMER
              </h2>
              <div className="text-gray-700 pl-11">
                <ul className="space-y-2">
                  <li className="flex items-start gap-3">
                    <span className="text-primary mt-1">•</span>
                    <span>Service is provided "as is."</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-primary mt-1">•</span>
                    <span>London Winners Ltd will not be held responsible for technical failures, missed draws, or circumstances beyond its reasonable control (force majeure).</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-primary mt-1">•</span>
                    <span>In such cases, users accept that the company has no obligation to reimburse or compensate for missed participation or potential winnings.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-primary mt-1">•</span>
                    <span>Users bear responsibility for verifying results and claiming prizes.</span>
                  </li>
                </ul>
              </div>
            </section>

            {/* Term 10 */}
            <section id="governing-law" className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow border border-gray-200">
              <h2 className="text-2xl font-bold text-primary mb-4 flex items-center gap-3">
                <span className="flex items-center justify-center w-8 h-8 bg-primary rounded-full text-white text-sm">10</span>
                GOVERNING LAW
              </h2>
              <div className="text-gray-700 pl-11">
                <ul className="space-y-2">
                  <li className="flex items-start gap-3">
                    <span className="text-primary mt-1">•</span>
                    <span>Governed by the laws of Malawi.</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-primary mt-1">•</span>
                    <span>Any disputes will be handled by competent courts in Malawi.</span>
                  </li>
                </ul>
              </div>
            </section>
          </div>

        </div>
      </main>

     
    </div>
  );
};

export default TermsAndConditions;